module.exports = __webpack_public_path__ + "static/media/FruitSpirit.925673c6.jpg";